import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { useFilterListaPraticheStore } from "stores/filter-store";
import { emptyArrayIfFalsy } from 'utils/general-utilities';
import Typography from '@mui/material/Typography'
import { isValidUser } from '../../../OnlyWithFunctions'
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';


const today = dayjs();

const FormFiltriDashboardV2 = ({ setOpenFilterMenu,fetchPratichePerExcel }) => {
  const tipoInserimento = emptyArrayIfFalsy(localStorage.getItem("TipologiaDiRichiesta") !== null, JSON.parse(localStorage.getItem("TipologiaDiRichiesta")));
  const statoPratica = emptyArrayIfFalsy(localStorage.getItem("StatoPratica") !== null, JSON.parse(localStorage.getItem("StatoPratica")));
  const assegnatari = emptyArrayIfFalsy(localStorage.getItem("DaAssegnareA") !== null, JSON.parse(localStorage.getItem("DaAssegnareA")))

  const { filters, setFilters } = useFilterListaPraticheStore();

  const getInitialFormValues = () => ({
    ndg: filters.body.ndg || "",
    codiceFiscale: filters.body.codiceFiscale || "",
    ragioneSociale: filters.body.ragioneSociale || "",
    esitoMonitoraggio: filters.body.esitoMonitoraggio || "",
    richiestaConsulenza: filters.body.richiestaConsulenza || "",
    daAssegnare: filters.body.daAssegnare || "",
    statoPraticaList: filters.body.statoPraticaList || [],
    tipoInserimento: filters.body.tipoInserimento || "",
    dataAperturaDal: filters.body.dataAperturaDal || null,
    dataAperturaAl: filters.body.dataAperturaAl || null,
    dataChiusuraDal: filters.body.dataChiusuraDal || null,
    dataChiusuraAl: filters.body.dataChiusuraAl || null,
  });
  const {
    register,
    handleSubmit,
    watch, setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: getInitialFormValues(),
    /*defaultValues: {
      dataAperturaDal: null,
      dataAperturaAl: null,
      dataChiusuraDal: null,
      dataChiusuraAl: null
    }*/
  })
  const watchFormValues = watch(["dataAperturaDal", "dataAperturaAl", "dataChiusuraDal", "dataChiusuraAl", "statoPraticaList"]);

/*  useEffect(() => {
  }, [watchFormValues])*/

  useEffect(() => {
    reset(getInitialFormValues());
  }, [filters]);

  // Parte handlers
  const onSubmit = (data) => {
    setFilters({ ...filters, body: { ...filters.body, ...data }})
    setOpenFilterMenu(false)
  }

  const onGeneraExcel = (data) =>{
    /*setFilters({ ...filters, body: { ...filters.body, ...data }})*/
    fetchPratichePerExcel()
    //setOpenFilterMenu(false)
    onSubmit(data)
  }
  // END Parte handlers

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ padding: "20px" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", justifyContent: "center", alignContent: "center", alignItems: "end", justifyItems: "center" }}>
        <TextField
          name={'NDG'}
          defaultValue={filters.body.ndg ? filters.body?.ndg : ""}
          id="standard-basic"
          label="ndg"
          variant="standard"
          {...register("ndg")}
        />
        <TextField
          name={'codiceFiscale'}
          defaultValue={filters.body.codiceFiscale ? filters.body?.codiceFiscale : ""}
          id="standard-basic"
          label="codice fiscale"
          variant="standard"
          {...register("codiceFiscale")}
        />
        <TextField
          name={'ragioneSociale'}
          defaultValue={filters.body.ragioneSociale ? filters.body?.ragioneSociale : ""}
          id="standard-basic"
          label="ragione sociale"
          variant="standard"
          {...register("ragioneSociale")}
        />

        {isValidUser('UTENTE_INTERNO') && (<FormControl variant="standard" sx={{
          width: "196px"
        }}>
          <InputLabel id="esito-monitoraggio-label">Esito Monitoraggio</InputLabel>
          <Select
            labelId="esito-monitoraggio-label"
            id="esito-monitoraggio-select"
            value={watch("esitoMonitoraggio") || ""}
            onChange={(e) => setValue("esitoMonitoraggio", e.target.value)}
            {...register("esitoMonitoraggio")}

          >
            <MenuItem value="SI">SI</MenuItem>
            <MenuItem value="NO">NO</MenuItem>
            {(watch("esitoMonitoraggio")!== null && watch("esitoMonitoraggio") !== '') && (<MenuItem value="" sx={{
              color: "red",
              fontStyle: "italic",
              fontSize: "0.875rem",
              textAlign: "center",
              justifyContent: "center"
            }}>rimuovi selezione</MenuItem>)}
          </Select>
        </FormControl>)}
        <FormControl variant="standard" sx={{
          width: "196px"
        }}>
          <InputLabel id="richiesta-consulenza-label">Richiesta Consulenza</InputLabel>
          <Select
            labelId="richiesta-consulenza-label"
            id="richiesta-consulenza-select"
            value={watch("richiestaConsulenza") || ""}
            onChange={(e) => setValue("richiestaConsulenza", e.target.value)}
            {...register("richiestaConsulenza")}

          >
            <MenuItem value="SI">SI</MenuItem>
            <MenuItem value="NO">NO</MenuItem>
            {(watch("richiestaConsulenza")!== null && watch("richiestaConsulenza") !== '') && (<MenuItem value="" sx={{
              color: 'red',
              fontStyle: 'italic',
              fontSize: '0.875rem',
              textAlign: 'center',
              justifyContent: 'center',
            }}>rimuovi selezione</MenuItem>)}

          </Select>
        </FormControl>
        {<FormControl variant="standard" sx={{
          width: "196px"
        }}>
          <InputLabel id="daAssegnare">Sale/Field analyst</InputLabel>
          <Select
            labelId="daAssegnare"
            id="daAssegnare-select"
            value={watch("daAssegnare") || ""}
            onChange={(e) => setValue("daAssegnare", e.target.value)}
            {...register("daAssegnare")}

          >{assegnatari.map(user => <MenuItem value={user}>{user}</MenuItem>)}

            {(watch("daAssegnare")!== null && watch("daAssegnare") !== '') && (<MenuItem value="" sx={{
              color: "red",
              fontStyle: "italic",
              fontSize: "0.875rem",
              textAlign: "center",
              justifyContent: "center"
            }}>rimuovi selezione</MenuItem>)}
          </Select>
        </FormControl>}
        <FormControl variant="standard" sx={{
          width: "196px"
        }}>
          <InputLabel id="stato-pratica-label">Stato pratica</InputLabel>
          <Select
            labelId="stato-pratica-label"
            defaultValue={filters.body.statoPraticaList ? filters.body?.statoPraticaList : []}
            id="stato-pratica-select"
            multiple
            label="stato-pratica"
            sx={{
              '& .MuiSelect-select': {
                padding: "6px 12px"
              }
            }}

            value={getValues("statoPraticaList") ? getValues("statoPraticaList") : (filters.body.statoPraticaList ? filters.body.statoPraticaList : [])}
            onChange={((e) => setValue("statoPraticaList", typeof e.target.value === 'string' ? e.target.value.split(",") : e.target.value))}
          >
            {statoPratica.map(stato => <MenuItem value={stato}>{stato}</MenuItem>)}

          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{
          width: "196px"
        }}>
          <InputLabel id="tipo-inserimento-label">Tipo Inserimento</InputLabel>
          <Select
            labelId="tipo-inserimento-label"
            id="tipo-inserimento-select"
            label="tipo-inserimento"
            sx={{
              '& .MuiSelect-select': {
                padding: "6px 12px"
              }
            }}
            value={watch("tipoInserimento") || ""}
            {...register("tipoInserimento")}
          >
            {tipoInserimento.map(tipo => <MenuItem value={tipo}>{tipo}</MenuItem>)}
            { (watch("tipoInserimento")) && (<MenuItem value="" sx={{
              color: 'red',
              fontStyle: 'italic',
              fontSize: '0.875rem',
              textAlign: 'center',
              justifyContent: 'center',
            }}>rimuovi selezione</MenuItem>)}

          </Select>
        </FormControl>
        {!isValidUser('UTENTE_INTERNO') && (<div></div>)}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it"  >

         {/* <DatePicker
            renderInput={(props) => (
              <TextField {...props}
                label="Data apertura dal"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': {
                    marginRight: '5px',
                  },
                }}
              />
            )}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataAperturaDal")}
            onChange={(event) => { setValue("dataAperturaDal", event.toISOString()) }}
          />

          <DatePicker
            renderInput={(props) => (
              <TextField {...props}
                label="Data apertura al"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': {
                    marginRight: '5px',
                  },
                }}
              />
            )}
            minDate={getValues("dataAperturaDal") !== null ? getValues("dataAperturaDal") : null}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataAperturaAl")}
            onChange={(event) => { setValue("dataAperturaAl", event.toISOString()) }}
          />

          <DatePicker
            renderInput={(props) => (
              <TextField {...props}
                label="Data chiusura dal"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': {
                    marginRight: '5px',
                  },
                }}
              />
            )}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataChiusuraDal")}
            onChange={(event) => { setValue("dataChiusuraDal", event.toISOString()) }}
          />

          <DatePicker
            renderInput={(props) => (
              <TextField {...props}
                label="Data chiusura al"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': {
                    marginRight: '5px',
                  },
                }}
              />
            )}
            minDate={getValues("dataChiusuraDal") !== null ? getValues("dataChiusuraDal") : null}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataChiusuraAl")}
            onChange={(event) => { setValue("dataChiusuraAl", event.toISOString()) }}
          />*/}
          <DatePicker
            renderInput={(params) => (
              <TextField
                {...params}
                label="Data apertura dal"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': { marginRight: '5px' },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {getValues("dataAperturaDal") && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setValue("dataAperturaDal", null)}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      )}
                    </>
                  ),
                }}
              />
            )}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataAperturaDal")}
            onChange={event => setValue("dataAperturaDal", event ? event.toISOString() : null)}
          />

          <DatePicker
            renderInput={(params) => (
              <TextField
                {...params}
                label="Data apertura al"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': { marginRight: '5px' },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {getValues("dataAperturaAl") && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setValue("dataAperturaAl", null)}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      )}
                    </>
                  ),
                }}
              />
            )}
            minDate={getValues("dataAperturaDal") !== null ? getValues("dataAperturaDal") : null}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataAperturaAl")}
            onChange={event => setValue("dataAperturaAl", event ? event.toISOString() : null)}
          />

          <DatePicker
            renderInput={(params) => (
              <TextField
                {...params}
                label="Data chiusura dal"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': { marginRight: '5px' },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {getValues("dataChiusuraDal") && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setValue("dataChiusuraDal", null)}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      )}
                    </>
                  ),
                }}
              />
            )}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataChiusuraDal")}
            onChange={event => setValue("dataChiusuraDal", event ? event.toISOString() : null)}
          />

          <DatePicker
            renderInput={(params) => (
              <TextField
                {...params}
                label="Data chiusura al"
                sx={{
                  width: '196px',
                  '& .MuiSvgIcon-root': { marginRight: '5px' },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      {getValues("dataChiusuraAl") && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setValue("dataChiusuraAl", null)}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      )}
                    </>
                  ),
                }}
              />
            )}
            minDate={getValues("dataChiusuraDal") !== null ? getValues("dataChiusuraDal") : null}
            maxDate={today}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '200px' }}
            value={getValues("dataChiusuraAl")}
            onChange={event => setValue("dataChiusuraAl", event ? event.toISOString() : null)}
          />

        </LocalizationProvider>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
        <Button type='submit' variant="outlined" size="medium">Filtra</Button>
        <Typography sx={{ marginLeft: "10px", marginRight: "10px" }}> o </Typography>
        <Button
          variant="outlined"
          size="medium"
          onClick={handleSubmit(onGeneraExcel)}
        >
          Genera Excel
        </Button>

      </Box>
    </form>
  );
}

export default FormFiltriDashboardV2;